import { gql } from "@apollo/client";

export const REGISTER_ALUMINI = gql`
  mutation AluminiRegister($registerInput: RegisterInput!) {
    aluminiRegister(RegisterInput: $registerInput)
  }
`;
